import { useBookingContext } from "modules/Booking/BookingContext"
import { getService } from "modules/BookingCommon/common/utils"

export function useService() {
    const [{ serviceGroup, onlineOrOffline, hasSlots }] = useBookingContext()

    return getService({ serviceGroup, onlineOrOffline, unCheckSlots: !hasSlots })
}
